import React from 'react';
import ReactDOM from "react-dom";
import Invoice from './invoice';
import UserProfile from './userProfile';
import logo from '../img/webkey-logo.png';
/*import styles from  './style.css';*/
/*import './style.css';*/

export default class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
            error: null,
            isLoaded: false,
            items: []
        };
    }

    userLogin() {
        var user = document.getElementById("user").value;;
        var pass = document.getElementById("pass").value;;
        var url = UserProfile.getURL() + '/invoice/ajax.php?event=login&user=' + user + '&pass=' + pass;
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                    //console.log(result);
                    if (result !== null) {
                        this.enter();
                    } else {
                        this.loginerror();
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                    this.loginerror();
                }
            )
    }

    loginerror() {
        ReactDOM.render(
            <Login name="Hibás azonosítás" value="Belépés" />,
            document.getElementById("invoiceShow")
        );
    }

    enter() {
        const { error, isLoaded, items } = this.state;
        var logedData = items.split('^');
        UserProfile.setHashName(logedData[0]);
        UserProfile.setUserID(logedData[1]);
        UserProfile.setUserVat(logedData[2]);
        UserProfile.setCompanyID(logedData[3]);
        var companyID = logedData[3];
        var data = { event: 'client-get', companyID: companyID };
        var url = UserProfile.getURL() + '/invoice/ajax.php';
        fetch(url, {
            method: "POST",
            body: new URLSearchParams(data),
            headers: new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8' })
        })
            .then(res => {
                this.isSubmitting = false;
                return res.json();
            })
            .then(
                (result) => {
                    this.isLoaded = true;
                    this.customer = result;
                    UserProfile.setAbbreviation(result.abbreviation);
                },
                (error) => {
                    this.isLoaded = true;
                    this.error = error;
                }
            )
        ReactDOM.render(
            <Invoice />,
            document.getElementById("invoiceShow")
        );
    }

    render() {
        return (
            <div className='invoice'>
                <div className='loged'>
                    <h1>Belépés - {this.props.name}</h1>
                    <div className='row'>
                        <input id='user' type='text' placeholder='Azonosító' />
                    </div>
                    <div className='row'>
                        <input id='pass' type='password' placeholder='Jelszó' />
                    </div>
                    <button className="push" onClick={() => this.userLogin()}>
                        {this.props.value}
                    </button>
                    <div className='logo'>
                        <img src={logo} />
                    </div>
                </div>
            </div>
        );
    }
}